import React, { useCallback, useRef } from "react";
import { Button, ButtonProps } from '@chakra-ui/react';

const FileUploadButton: React.FC<ButtonProps> = ({
  onChange,
  name,
  ...props
}) => {
  const fileUploadField = useRef<HTMLInputElement>();

  const handleClick = useCallback(() => {
    fileUploadField?.current?.click()
  }, [fileUploadField?.current])

  return (
    <>
      <input
        ref={fileUploadField}
        type="file"
        onChange={onChange}
        name={name}
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          left: 0,
          bottom: 0,
          margin: 0,
          padding: 0,
          opacity: 0,
          width: 1,
          height: 1,
        }}
      />
      <Button {...props} onClick={handleClick} />
    </>
  )
};

export default React.memo(FileUploadButton);
